module.exports = {"511502001":"北城街道","511502002":"东城街道","511502003":"南城街道","511502004":"西城街道","511502006":"西郊街道","511502007":"安阜街道","511502008":"白沙湾街道","511502010":"象鼻街道","511502011":"沙坪街道","511502101":"李庄镇","511502102":"菜坝镇","511502104":"金坪镇","511502106":"高店镇","511502108":"牟坪镇","511502109":"李端镇","511502110":"邱场镇","511502111":"宗场镇","511502112":"宋家镇","511502113":"明威镇","511502114":"凉姜镇","511502115":"思坡镇","511502116":"白花镇","511502117":"孔滩镇","511502118":"双谊镇","511502119":"王场镇","511502120":"永兴镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511502.json
// module id = 2355
// module chunks = 0